"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Title = _interopRequireDefault(require("../Title"));

var _InterFaceSvg = _interopRequireDefault(require("../Business/InterFaceSvg"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var plays = {
  checkedIf: false
}; // 是否暂停
// 改变切换进度条控制

function refChecked(node) {
  if (node) {
    node.childNodes[2].style['transform-origin'] = "0 100%";
    node.childNodes[2].style.background = "#006EFF";
    node.childNodes[2].style.width = '100%';
    node.childNodes[2].style.height = '2px';
  }
}

function SceneTabs(props) {
  var _a = props || {},
      flexTitle = _a.flexTitle,
      desc = _a.desc,
      style = _a.style,
      _b = _a.configuration,
      configuration = _b === void 0 ? [] : _b;

  var _configuration_title = [];

  var _c = (0, _react.useState)(0),
      stindex = _c[0],
      setStindex = _c[1];

  var _d = (0, _react.useState)(false),
      bgif = _d[0],
      setBgif = _d[1];

  configuration.forEach(function (item) {
    var _a = item || {},
        title = _a.title,
        description = _a.description;

    _configuration_title.push({
      title: title,
      description: description
    });
  });
  var useRefLi = (0, _react.useRef)(null);
  var right_ref = (0, _react.useRef)(null); // 当前元素的个数

  var listMapLen = configuration ? configuration.length : 0;
  var i = 0; // 开始索引

  var time = 1000; // 滚动时间

  var currentLi = 0; // 当前索引

  var changeCurrentBlock = function changeCurrentBlock(i) {
    if (useRefLi.current && right_ref.current) {
      var currentRefLi = useRefLi.current.childNodes[currentLi % listMapLen]; // const _right_ref_ = (right_ref.current.childNodes[
      //   currentLi % listMapLen
      // ] as unknown) as nodeType;

      currentRefLi.childNodes[2].style.transform = "scale(" + 40 / 40 / time * (i || 0) + ",1)"; // 进度条
      // currentRefLi.childNodes[0].className = 'scene-tabs-h4 scene-tabs-h4--active'; // 左侧标题是否选中
      // _right_ref_.style.display = 'block'; // 显示左侧内容区域

      refChecked(currentRefLi);
    }
  }; // 自动计算滚动


  var auto_compute = function auto_compute() {
    if (plays.checkedIf) return;
    i++;

    if (i % time === 0) {
      i = 0;
      currentLi += 1;
      var r_index = currentLi;

      if (right_ref.current) {
        var right_len = right_ref.current.childNodes.length;
        r_index = r_index % right_len;
      }

      setStindex(r_index); // 自动滚动当前目标元素

      var currentNode = {};

      if (useRefLi.current) {
        currentNode = useRefLi.current.childNodes[currentLi % listMapLen > 0 ? currentLi % listMapLen - 1 : listMapLen - 1]; // const currentRight = (right_ref.current!.childNodes[
        //   currentLi % listMapLen > 0 ? (currentLi % listMapLen) - 1 : listMapLen - 1
        // ] as unknown) as nodeType;

        currentNode.childNodes[2].style.transform = "scale(0,1)"; // currentNode.childNodes[0].className = 'scene-tabs-h4';
        // currentRight.style.display = 'none';

        refChecked(currentNode);
      }
    }

    changeCurrentBlock(i);
    requestAnimationFrame(function () {
      auto_compute();
    });
  }; // 自定义操作清除


  var clear_li = function clear_li(index) {
    if (useRefLi.current && right_ref.current) {
      // 控制上一层样式
      var preNode = useRefLi.current.childNodes[currentLi % listMapLen]; // const preRight = (right_ref.current.childNodes[
      //   currentLi % listMapLen
      // ] as unknown) as nodeType;

      preNode.childNodes[2].style.transform = "scale(0,1)"; // preNode.childNodes[0].className = 'scene-tabs-h4';
      // preRight.style.display = 'none';

      refChecked(preNode); // 进入当前一层样式

      currentLi = index;
      var nextNode = useRefLi.current.childNodes[index % listMapLen]; // const nextRight = (right_ref.current.childNodes[index % listMapLen] as unknown) as nodeType;

      nextNode.childNodes[2].style.transform = "scale(1,1)"; // nextNode.childNodes[0].className = 'scene-tabs-h4 scene-tabs-h4--active';
      // nextRight.style.display = 'block';

      refChecked(nextNode);
    }
  };

  var checked = function checked(index) {
    // 暂停
    setStindex(index);
    plays.checkedIf = true; // 强制选中

    clear_li(index);

    if (useRefLi.current) {
      setBgif(true);
    }
  };

  (0, _react.useEffect)(function () {
    var _w_windows = document.documentElement.offsetWidth || document.body.offsetWidth;

    if (listMapLen > 1 && _w_windows > 768) {
      auto_compute();
    } else {
      plays.checkedIf = true; // 强制选中

      clear_li(0);
    }
  }, []);

  var _accordion = configuration ? configuration.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        imageUrl = _a.imageUrl,
        product = _a.product,
        related = _a.related,
        description = _a.description,
        article = _a.article,
        filedVideoBg = _a.filedVideoBg,
        filedVideoList = _a.filedVideoList;

    return {
      title: title,
      tabTitle: title,
      description: description,
      key: Number(index) + 1,
      content: article,
      filedVideoBg: filedVideoBg,
      filedVideoList: filedVideoList,
      imageSrc: imageUrl,
      product: product,
      related: related
    };
  }) : [];

  var seneList = configuration.length;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    style: (0, _typeof2["default"])(style) === 'object' ? style : {},
    className: 'flex-default-scene-tabs-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scene-tabs-container__children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    desc: desc,
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'scene-tabs-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'scene-tabs-container-left',
    ref: useRefLi
  }, _configuration_title.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-tabs-container-left__list',
      "report-event": "click_sceneTabs_tab",
      "report-ext1": index,
      "report-ext2": _item.title || '',
      onClick: checked.bind(null, index),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: (0, _classnames["default"])('scene-tabs-h4', {
        'scene-tabs-h4--active': index == stindex
      })
    }, _item.title), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-tabs-description'
    }, _item.description), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('scene-tabs-process', {
        'scene-tabs-process--stop': bgif
      })
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: right_ref,
    className: 'scene-tabs-container-right'
  }, configuration.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        imageUrl = _a.imageUrl,
        article = _a.article,
        related = _a.related,
        product = _a.product;

    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: (0, _classnames["default"])('scene-tabs-container-right__section', {
        'scene-tabs-container-right__section--show': index == stindex
      })
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: 'scene-tabs-h4 scene-tabs-h4-right'
    }, title), imageUrl ? /*#__PURE__*/_react["default"].createElement(PictureComponent, {
      style: {
        width: '10px',
        borderRadius: '4px',
        marginTop: '16px',
        marginBottom: '24px'
      },
      imageSrc: imageUrl,
      seneList: seneList
    }) : null, article ? /*#__PURE__*/_react["default"].createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article
      }
    }) : null, /*#__PURE__*/_react["default"].createElement("h5", {
      className: 'scene-tabs-h5'
    }, related), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-ul-container'
    }, product && product.map(function (items, i) {
      var _a = items || {},
          title = _a.title,
          logo = _a.logo,
          logoHov = _a.logoHov,
          url = _a.url;

      var logoUrl = (0, _utils.fomateFileData)(logo).url;
      var logoHovUrl = (0, _utils.fomateFileData)(logoHov).url;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'scene-ul-container-r-div',
        key: i
      }, url ? /*#__PURE__*/_react["default"].createElement("a", {
        "report-event": "click_sceneTabs_product_href",
        "report-ext1": i,
        "report-ext2": title || '',
        "report-ext3": url || '',
        href: url
      }, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
        enterUrl: logoUrl || logoHovUrl,
        leaveUrl: logoHovUrl || logoUrl
      }), title) : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
        enterUrl: logoUrl || logoHovUrl,
        leaveUrl: logoHovUrl || logoUrl
      }), title));
    })));
  }))))), /*#__PURE__*/_react["default"].createElement(FlexAccordion, {
    style: style,
    configuration: _accordion,
    flexTitle: flexTitle
  }));
}

var _default = SceneTabs; // 图片组件控制

exports["default"] = _default;

function PictureComponent(props) {
  var imageSrc = props.imageSrc,
      style = props.style,
      _a = props.seneList,
      seneList = _a === void 0 ? {} : _a;

  var _b = (0, _utils.fomateFileData)(imageSrc),
      url = _b.url,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c;

  var _d = (0, _react.useState)({}),
      styles = _d[0],
      setStyls = _d[1];

  var _e = (0, _react.useState)({}),
      divStyle = _e[0],
      setDivStyle = _e[1];

  (0, _react.useEffect)(function () {
    var imgLoad = new Image();

    if (url) {
      imgLoad.src = url;
    }

    imgLoad.onload = function () {
      var collectStyles = {};
      var divStyle = {};

      if (imgLoad.width < imgLoad.height) {
        var imgheight = void 0;

        if (seneList <= 5) {
          imgheight = 345;
        } else if (5 < seneList && seneList < 9) {
          imgheight = 460;
        } else {
          imgheight = 517;
        }

        collectStyles = {
          height: imgheight + "px",
          width: 'auto'
        };
        divStyle = {
          textAlign: 'center'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }

      setDivStyle(divStyle);
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: __assign({}, divStyle)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign(__assign({}, style), styles),
    src: url,
    alt: alt
  }));
} // 移动端组件控制


function FlexAccordion(props) {
  var configuration = props.configuration,
      flexTitle = props.flexTitle,
      style = props.style;

  var _a = (0, _react.useState)(1),
      saveKey = _a[0],
      setSaveKey = _a[1];

  var childrenNodes = {};
  var getHeightVal = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (getHeightVal && getHeightVal.current) {
        childrenNodes = getHeightVal.current.childNodes; // todo optimize
        // 12 初始状态下少12 offsetHeight
        // 24 距离底部距离

        for (var i = 0; i < childrenNodes.length; i++) {
          var getNode = getHeightVal.current.childNodes[i];
          var getNodeChild = getNode.childNodes[0];
          var getNodeChildLast = getNodeChild.lastChild;
          getNodeChildLast.style.height = getNodeChildLast.childNodes[0].offsetHeight + (i === 0 ? 24 : 0) + "px";
        }
      }
    }, 1000);
  }, []);

  var checkTabsStatus = function checkTabsStatus(key) {
    var _childrenNodes = getHeightVal;

    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];

      if (i == Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            // 24 距离底部距离
            transformClass.lastChild.style.height = transformClass.lastChild.childNodes[0].offsetHeight + 24 + "px";
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    }; // todo optimize


    for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-scene-accordion',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    var _a = item,
        description = _a.description,
        tabTitle = _a.tabTitle,
        key = _a.key,
        related = _a.related,
        product = _a.product,
        content = _a.content,
        // filedVideoBg,
    // filedVideoList,
    imageSrc = _a.imageSrc;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i == 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        checkTabsStatus(key);

        if (key === saveKey) {
          setSaveKey(0);
        } else {
          setSaveKey(key);
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-title__scene-tabs-h4'
    }, tabTitle), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "design-iconfont d-icon"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    }))), saveKey - 1 === i ? /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-title__scene-tabs-description'
    }, description) : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-content"
    }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
      imageSrc: imageSrc
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-content__article',
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), /*#__PURE__*/_react["default"].createElement("h5", {
      className: 'scene-tabs-h5',
      style: {
        marginTop: '24px'
      }
    }, related), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scene-ul-container'
    }, product && product.map(function (items, i) {
      var _a = items || {},
          title = _a.title,
          logo = _a.logo,
          logoHov = _a.logoHov,
          url = _a.url;

      var logoUrl = (0, _utils.fomateFileData)(logo).url;
      var logoHovUrl = (0, _utils.fomateFileData)(logoHov).url;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'scene-ul-container-r-div',
        key: i
      }, url ? /*#__PURE__*/_react["default"].createElement("a", {
        "report-event": "click_sceneTabs_product_href",
        "report-ext1": i,
        "report-ext2": title || '',
        "report-ext3": url || '',
        href: url
      }, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
        enterUrl: logoUrl || logoHovUrl,
        leaveUrl: logoHovUrl || logoUrl
      }), title) : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_InterFaceSvg["default"], {
        enterUrl: logoUrl || logoHovUrl,
        leaveUrl: logoHovUrl || logoUrl
      }), title));
    }))))));
  }))))));
}